import React from 'react'
import {IconButton, Checkbox} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import CreateIcon from '@material-ui/icons/Create'

const FilteredViewItem = ({data, selectedFilteredView, onClick, onClickEdit}) => {
  const getSelectedView = () => {
    return selectedFilteredView?.some(v => v?._id === data?._id) || false
  }

  return (
    <div className="c-calendar-views__item c-calendar-views__item--child ap-flex--align-center">
      <Checkbox
        size={'small'}
        checkedIcon={
          <div
            style={{
              height: 16,
              width: 16,
              margin: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '2px',
              background: data.color,
            }}
          >
            <CheckIcon
              style={{fontSize: 12, color: data.color === '#ffffff' ? '#1d2331' : '#ffffff'}}
            />
          </div>
        }
        checked={getSelectedView()}
        value={data}
        onClick={e => onClick(e, data)}
      />
      <span
        className="ap-typography ap-typography--sm ap-ellipsis cursor_pointer"
        title={data.name}
        onClick={e => onClick(e, data)}
      >
        {data.name}
      </span>
      <div className="ap-flex ap-flex--end">
        <IconButton
          className="ap-icon-button ap-icon-button--square btn-hover btn-hover--hidden"
          style={{color: '#596175'}}
          onClick={e => onClickEdit(e, data)}
        >
          <CreateIcon style={{transform: 'scale(.60)'}} />
        </IconButton>
      </div>
    </div>
  )
}

export default FilteredViewItem
